let view = null;

export default {
	namespace: 'single-interview',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: InterviewView } = await import(
			/* webpackChunkName: "interview-view" */ '../../templates/InterviewView'
		);
		view = new InterviewView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
